import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DeferredFragmentIdentifieryfmj5mbsp1mh as DeferredFragmentIdentifier } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/DeferredFragmentIdentifier.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/BufferedSourceJsonReader.mjs';
import { readAny17j2jqaxubdko as readAny } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function mergeData($this, incrementalItem) {
  var tmp = incrementalItem.u4('data');
  var data = (tmp == null ? true : isInterface(tmp, KtMap())) ? tmp : THROW_CCE();
  var tmp_0 = incrementalItem.u4('path');
  var path = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = $this.t66_1.u4('data');
  var mergedData = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : THROW_CCE();
  if (!(data == null)) {
    var tmp_2 = nodeAtPath($this, mergedData, path);
    var nodeToMergeInto = (!(tmp_2 == null) ? isInterface(tmp_2, KtMutableMap()) : false) ? tmp_2 : THROW_CCE();
    deepMerge($this, nodeToMergeInto, data);
    var tmp0 = $this.u66_1;
    var tmp_3 = incrementalItem.u4('label');
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new (DeferredFragmentIdentifier())(path, (tmp_3 == null ? true : typeof tmp_3 === 'string') ? tmp_3 : THROW_CCE());
    tmp0.i2(element);
  }
}
function deepMerge($this, destination, map) {
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = map.l3().p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.m3();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.n3();
    var tmp;
    if (destination.s4(key)) {
      var tmp_0 = destination.u4(key);
      tmp = !(tmp_0 == null) ? isInterface(tmp_0, KtMutableMap()) : false;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_1 = destination.u4(key);
      var fieldDestination = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap()) : false) ? tmp_1 : THROW_CCE();
      var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap()) : false) ? value : null;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = "'" + key + "' is an object in destination but not in map";
        throw IllegalStateException().o(toString(message));
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      var fieldMap = tmp_2;
      deepMerge($this, fieldDestination, fieldMap);
    } else {
      // Inline function 'kotlin.collections.set' call
      destination.x4(key, value);
    }
  }
}
function jsonToMap($this, json) {
  var tmp = readAny(new (BufferedSourceJsonReader())(json));
  return (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
}
function nodeAtPath($this, map, path) {
  var node = map;
  var _iterator__ex2g4s = path.p1();
  while (_iterator__ex2g4s.q1()) {
    var key = _iterator__ex2g4s.r1();
    var tmp;
    if (!(node == null) ? isInterface(node, KtList()) : false) {
      var tmp_0 = node;
      tmp = tmp_0.r2(typeof key === 'number' ? key : THROW_CCE());
    } else {
      if (!(!(node == null) ? isInterface(node, KtMap()) : false))
        THROW_CCE();
      // Inline function 'kotlin.collections.get' call
      var this_0 = node;
      tmp = (isInterface(this_0, KtMap()) ? this_0 : THROW_CCE()).u4(key);
    }
    node = tmp;
  }
  return node;
}
var DeferredJsonMergerClass;
function DeferredJsonMerger() {
  if (DeferredJsonMergerClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.s66_1 = LinkedHashMap().bc();
        this.t66_1 = this.s66_1;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp_0.u66_1 = LinkedHashSet().s2();
        this.v66_1 = this.u66_1;
        this.w66_1 = true;
        this.x66_1 = false;
      }
      y66(payload) {
        var payloadMap = jsonToMap(this, payload);
        return this.z66(payloadMap);
      }
      z66(payload) {
        if (this.t66_1.n1()) {
          // Inline function 'kotlin.collections.plusAssign' call
          this.s66_1.z4(payload);
          return this.t66_1;
        }
        var tmp = payload.u4('incremental');
        var incrementalList = (!(tmp == null) ? isInterface(tmp, KtList()) : false) ? tmp : null;
        if (incrementalList == null) {
          this.x66_1 = true;
        } else {
          this.x66_1 = false;
          // Inline function 'kotlin.collections.mutableListOf' call
          var mergedErrors = ArrayList().p2();
          // Inline function 'kotlin.collections.mutableListOf' call
          var mergedExtensions = ArrayList().p2();
          var _iterator__ex2g4s = incrementalList.p1();
          while (_iterator__ex2g4s.q1()) {
            var incrementalItem = _iterator__ex2g4s.r1();
            mergeData(this, incrementalItem);
            var tmp_0 = incrementalItem.u4('errors');
            var tmp0_safe_receiver = (!(tmp_0 == null) ? isInterface(tmp_0, KtList()) : false) ? tmp_0 : null;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              addAll(mergedErrors, tmp0_safe_receiver);
            }
            var tmp_1 = incrementalItem.u4('extensions');
            var tmp1_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap()) : false) ? tmp_1 : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.plusAssign' call
              mergedExtensions.i2(tmp1_safe_receiver);
            }
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!mergedErrors.n1()) {
            // Inline function 'kotlin.collections.set' call
            this.s66_1.x4('errors', mergedErrors);
          } else {
            this.s66_1.y4('errors');
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!mergedExtensions.n1()) {
            var tmp0 = this.s66_1;
            var tmp2 = 'extensions';
            // Inline function 'kotlin.collections.set' call
            var value = mapOf(to('incremental', mergedExtensions));
            tmp0.x4(tmp2, value);
          } else {
            this.s66_1.y4('extensions');
          }
        }
        var tmp_2 = this;
        var tmp_3 = payload.u4('hasNext');
        var tmp2_elvis_lhs = (tmp_3 == null ? true : typeof tmp_3 === 'boolean') ? tmp_3 : THROW_CCE();
        tmp_2.w66_1 = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
        return this.t66_1;
      }
      y3n() {
        this.s66_1.a5();
        this.u66_1.a5();
        this.w66_1 = true;
        this.x66_1 = false;
      }
    }
    initMetadataForClass($, 'DeferredJsonMerger', DeferredJsonMerger);
    DeferredJsonMergerClass = $;
  }
  return DeferredJsonMergerClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.v4().t2('hasNext');
}
//region block: exports
export {
  DeferredJsonMerger as DeferredJsonMerger16i62uujz1qml,
  isDeferred as isDeferred3jq83655znees,
};
//endregion

//# sourceMappingURL=DeferredJsonMerger.mjs.map
